import DatabaseMonitoring from "../Components/DatabaseMonitoring/DatabaseMonitoring";

const DatabaseMonitoringPage = () => {
  return <DatabaseMonitoring />;
};

export default DatabaseMonitoringPage;
